import { z } from 'zod';
export const abnValidationSchema = z.object({
    id: z.string(),
    data: z
        .object({
        services: z
            .array(z.object({
            service: z.string(),
            reason: z.string(),
            estimatedCost: z.string(),
        }))
            .optional(),
        language: z.string({ message: 'Please select a language' }),
        serviceOption: z.string({ message: 'Please select an option' }),
        patientSigned: z.literal(true, {
            errorMap: () => ({ message: 'Patient signature is required' }),
        }),
        additionalNotes: z.string().optional(),
        signedDate: z.string().optional(),
        representativeSigned: z.boolean().optional(),
        authorizedRepName: z.string().optional(),
    })
        .superRefine((data, ctx) => {
        if (data.representativeSigned && !data.authorizedRepName?.trim()) {
            ctx.addIssue({
                path: ['authorizedRepName'],
                code: z.ZodIssueCode.custom,
                message: 'Authorized representative name is required',
            });
        }
        if (data.patientSigned && !data.signedDate) {
            ctx.addIssue({
                path: ['signedDate'],
                code: z.ZodIssueCode.custom,
                message: 'Signature date is required',
            });
        }
    }),
});
